import React from 'react'

const Error = ({error}) => {
  return ( 
    <p className='error mb-0'>{error}</p>
  )
}

export default Error